import { useLayoutEffect, useRef } from 'react';

import { useImpersonatorEmailFromStorage } from '@/services/storage';
import { redirectTo } from '@/utils/navigation';

const useImpostorRefresh = () => {
  const impostorEmail = useImpersonatorEmailFromStorage();
  const prevImpostorEmailRef = useRef<string | null | undefined>(undefined);

  useLayoutEffect(() => {
    if (prevImpostorEmailRef.current === undefined) {
      prevImpostorEmailRef.current = impostorEmail;
      return;
    }
    if (prevImpostorEmailRef.current !== impostorEmail) {
      prevImpostorEmailRef.current = impostorEmail;
      setTimeout(() => {
        redirectTo('/');
      }, 250);
    }
  }, [impostorEmail]);
};

export default useImpostorRefresh;
